<template>
	<el-dialog :visible.sync="showcargospec" :title="title" width="400px" :append-to-body="true" :close-on-click-modal="false">
		<div class="inputBox" style="height:120px">
			<el-form label-width="80px" size="mini">
				<el-form-item label="规格名称"><el-input v-model="specinfo.spec_name" ref="spec_name"></el-input></el-form-item>
				<el-form-item label="规格值">
					<el-select style="width:100%;" v-model="specinfo.spec" multiple allow-create filterable default-first-option size="mini" 
							no-match-text="">
							<span slot="empty"></span>
							</el-select>
				</el-form-item>
			</el-form>
		</div>
		<span slot="footer" class="dialog-footer">
			<div style="text-align:center;width:100%;padding-top:10px">
				<el-button size="mini" type="success" @click.native="savecargospec">保存</el-button>
				<el-button size="mini" style="margin-left:10px" type="info" plain @click.native="showcargospec = false">关闭</el-button>
			</div>
		</span>
	</el-dialog>
</template>

<script>
import Utils from '../../lib/util.js';
export default {
	props: {},
	data() {
		return {
			showcargospec: false,
			title: '',
			specinfo: {
				spec_name: '',
				spec: [],
				id: ''
			},
			divclass: 'inputBox',
			cargotype:''
		};
	},
	methods: {
		init(param) {
			this.specinfo={
				spec_name: '',
				spec: [],
				id: ''
			}
			this.cargotype='';
			this.title=param.title;
			this.showcargospec = true;
			if (param.spec_name != undefined) this.specinfo.spec_name = param.spec_name;
			if (param.spec != undefined) this.specinfo.spec = param.spec;
			if (param.id != undefined) this.specinfo.id = param.id;
			if (param.cargotype != undefined) this.cargotype = param.cargotype;
			var that=this;
			this.$nextTick(function(){
				that.$refs.spec_name.focus();
			});
		},
		//保存规格
		savecargospec() {
			var that=this;
			if (this.specinfo.spec_name == '') {
				this.$tool.message('请填写规格名称', 0);
				return false;
			}
			if (this.specinfo.spec == '') {
				this.$tool.message('请填写规格值', 0);
				return false;
			}
			var paraminfo = this.specinfo;
			paraminfo.cargotype=this.cargotype;
			paraminfo.userid = localStorage.getItem('userid');
			this.$tool.loading('正在保存', this.divclass);
			this.$apipost.post.SaveSpec_SC({ paraminfo: paraminfo }).then(res => {
				this.$tool.loadingclose();
				if (res.state == '1') {
					this.$tool.message('保存成功', 1);
					that.showcargospec = false;
					that.$parent.refreshgrid(true);
				} else this.$tool.message(res.message, 0);
			});
		}
	}
};
</script>

<style></style>
